{
  "title": "Locate Animals or Plants",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level divination (ritual)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a bit of fur from a bloodhound)",
  "duration": "Instantaneous",
  "description": [
    "Describe or name a specific kind of beast or plant. Concentrating on the voice of nature in your surroundings, you learn the direction and distance to the closest creature or plant of that kind within 5 miles, if any are present."
  ],
  "spellLists": ["bard", "druid", "ranger"]
}
